import companySearchManifest from './manifests/company_search';
import companyFilterManifest from './manifests/company_filter';

const manifest = {
  company_search: companySearchManifest,
  company_filter: companyFilterManifest,
};

export default manifest;
